import { defineComponent as _defineComponent } from 'vue'
import { ref, onMounted, computed, useContext } from '@nuxtjs/composition-api'
import { useCustomLogicModel } from '@shared/model'
import { getCurrentDate } from '@shared/utils'
import ReviewInteresting from './ReviewInteresting.vue'
import { useOrderModel } from '@entities/order'
import { useLoyaltyModel } from '../../loyalty'


export default /*#__PURE__*/_defineComponent({
  __name: 'ReviewTopBlock',
  setup(__props) {

const { $cookies } = useContext()

const payedStatus = ref<string>('')
const payDate = ref<string>('')

const customLogicModel = useCustomLogicModel()
const orderModel = useOrderModel()
const loyaltyModel = useLoyaltyModel()

const displayBonuses = computed(() => {
  return orderModel.orderData?.global_system_loyalty?.code === 'prime_hill' && !(orderModel.orderData.global_system_loyalty?.application_loyalty && loyaltyModel.sumDiscountPrimeHill && !orderModel.orderData.bonus)
})

onMounted(async () => {
  const orderDataFromCookie = await $cookies.get('order')
  // Дата и время оплаты заказа
  const currentDate = getCurrentDate()
  payDate.value = currentDate

  payedStatus.value =
    orderDataFromCookie && orderDataFromCookie.payedStatus
      ? 'Полностью'
      : 'Частично'
})


return { __sfc: true,$cookies, payedStatus, payDate, customLogicModel, orderModel, loyaltyModel, displayBonuses, ReviewInteresting }
}

})